<template>
  <div class="animated fadeIn list-of-jurnal">
    <b-card>
      <div slot="header">Form - Jurnal Eliminasi/Konsolidasi 
        <div class="card-header-actions">
          <b-button variant="primary" v-if="saveEnabled" @click="save()"><i class="fa fa-save"></i> Save</b-button>
          <b-button variant="secondary" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row>
        <b-col lg="4">
          <b-input-group >
              <!-- <b-input-group-prepend><label>Jurnal Number</label></b-input-group-prepend>
              <b-form-input v-model="model.nomor"></b-form-input>  -->
              <b-input-group-append><span class="ml-2 pt-2 mr-1">Jurnal Date</span></b-input-group-append>
              <b-form-input v-model="model.tanggal" type="date"  :state="!$v.model.tanggal.$error" :disabled="(kunciTgl==true)"></b-form-input>                                        
          </b-input-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined responsive hover
        style="font-size:smaller;" 
        :items="ayatJurnal.items"
        :fields="tblFields"
      >
        <template v-slot:cell(index)="data">
          {{data.index + 1}}
        </template>
        <template v-slot:cell(kodeacc)="data">
          {{data.item.kodeacc}} | {{data.item.namaacc}}
        </template>
        <template v-slot:cell(umasuk)="data">
          {{data.item.umasuk|numFormat('0,0.00')}}
        </template>
        <template v-slot:cell(ukeluar)="data">
          {{data.item.ukeluar|numFormat('0,0.00')}}
        </template>

        <template v-slot:cell(action)="data">
          <div class="text-center">
          <a href="javascript:void(0)" @click="editAyatJurnal(data.item,data.toggleDetails)">
            <i class="fa fa-pencil"></i>
          </a>
          |
          <a href="javascript:void(0)" class="text-danger" @click="delAyatJurnal(data.index)">
            <i class="fa fa-trash"></i>
          </a>
          </div>
        </template>
        <template v-slot:row-details="row">
          <b-card no-body class="row-details-form">
              <b-row class="justify-content-center" >
              <b-col lg="6">
                  <b-input-group >
                      <b-input-group-prepend><label>GL Account #</label></b-input-group-prepend>
                      <b-form-input readonly v-model="ayatJurnal.obj.glAccount" @keyup.13.native="lkuCoaShow=true" :state="!$v.ayatJurnal.obj.kodeacc.$error"></b-form-input>
                      <b-input-group-append>
                      <b-btn text="Button" @click="lkuCoaShow=true" id="glAccount">
                          <i class="fa fa-search"></i>
                      </b-btn>
                      </b-input-group-append>
                  </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>Company Name</label></b-input-group-prepend>
                        <b-form-input v-model="ayatJurnal.obj.company" ></b-form-input>
                        <b-input-group-append >
                            <b-btn text="Button" @click="lkuCompanyShow=true" >
                                <i class="fa fa-search"></i>
                            </b-btn>
                        </b-input-group-append>
                        
                    </b-input-group>
              </b-col>
              <b-col lg="6">
                  <b-input-group >
                      <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                        <b-form-input v-model="ayatJurnal.obj.uraian" :state="!$v.ayatJurnal.obj.uraian.$error"></b-form-input>
                  </b-input-group>

                  <b-input-group >
                      <b-input-group-prepend><label>Amount Debit</label></b-input-group-prepend>
                      <my-number class="form-control text-right" v-model="ayatJurnal.obj.umasuk" :precision="2" @change.native="mutasiDb"></my-number>
                      <b-input-group-append class="ml-2">
                      <b-btn text="Button" variant="warning" @click="mutasiBalik()" >
                          <i class="fa fa-exchange"></i>
                      </b-btn>
                      </b-input-group-append>
                    <b-input-group-append><span class="ml-2 pt-2 mr-1">Amount Credit</span></b-input-group-append>
                      <my-number class="form-control text-right" separator="," v-model="ayatJurnal.obj.ukeluar" :precision="2" @change.native="mutasiCr"></my-number>
                  </b-input-group>
              </b-col>
            </b-row>
            <b-row class="justify-content-center mb-2">
                <b-button class="btn btn-success mr-1" @click="saveAyatJurnal()">Update</b-button>
                <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Close</b-button>
            </b-row>
          </b-card>
        </template>                        
      <template slot="bottom-row" slot-scope="data">
        <td colspan="2">          
          <b-row class="m-0" no-gutters="">
            <div class="mt-1">Total {{totalRow}} lines </div>
            <b-button size="sm" class="ml-1" @click="addAyatJurnal" >Add Journal Line</b-button>
          </b-row>
        </td>
        <td class="tebal total">TOTAL ({{uanguser}})</td>
        <td class="tebal total">{{totalDb|numFormat('0,0.00')}}</td>
        <td class="tebal total">{{totalCr|numFormat('0,0.00')}}</td>
        <td :colspan="(data.columns-5)"> </td>
      </template>
      </b-table>
      <b-row class="justify-content-center mt-2">
          <b-button variant="primary" v-if="saveEnabled" @click="save()"><i class="fa fa-save"></i> Save</b-button>
          <b-button variant="secondary" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
      </b-row>
    </b-card>
        <b-modal v-model="lkuCoaShow" size="lg" :hide-footer="true" title="Consolidation Account" :centered="true" :lazy="true">
            <lku-coa @click="onSelectLkuCoa" :tahun="tahun" :key="tahun"></lku-coa>
        </b-modal>        
        <b-modal v-model="lkuCompanyShow" size="lg"  :hide-footer="true" title="Consolidation Company" :centered="true">
            <lku-company @click="onSelectLkuCompany"></lku-company>
        </b-modal>        

  </div>
</template>

<style lang="scss">
    .list-of-jurnal {
      table {
        td.tebal {
            font-weight: bold;
        }
            
        td.total {
            border-top: 2px solid #000 !important;
            background: #e6e6e6 !important;
            text-align:right;
        }

      }
    }
    .row-details-form {
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
      .input-group {
          .input-group-prepend {
              label {
                  width: 130px !important;
                  margin-right:5px;
              }
          }
      }

    }
</style>


<script>
import toastr from "mini-toastr";
import moment from 'moment';
import myNumber from "../../components/my-number";
import vDim from "../lookup/dim";
import lkuCoa from "../lookup/lkuConsolidaCoa";
import lkuCompany from "../lookup/lkuConsolidaCompany"
import buku from "../../apis/consolidabuku";
import { validationMixin } from "vuelidate";
import { required, minValue, maxLength, numeric } from "vuelidate/lib/validators";
toastr.init();

export default {
  components: { myNumber, vDim, lkuCoa, lkuCompany},
  mixins: [validationMixin],
  validations: {
    model: {
        tanggal: { required },
    },
    ayatJurnal: {
        obj :{
            kodeacc: { required },
            uraian: { required },
        }
    }
  }, 
  data() {
    return {
      saveEnabled: true,
      lkuCompanyShow: false,
      lkuCoaShow:false,
      tahun:moment(this.$store.state.user.tglaktifconsol).format('YYYY'),
      model:{kodejurnal:'-', nomor:'', tanggal:''},
      totalDb:0,
      totalCr:0,
      totalRow:0,
      fsubkode1: '', 
      kodefield1: '', 
      subkode1: '', 
      fsubkode2: '',
      kodefield2: '', 
      subkode2:'',       
      ayatJurnal: {
        items: [],
        selected:{},
        obj:{ kodeacc:'', glAccount:'',uraian:''},
      },
      kunciTgl: false,
      tblFields:[
          {
            key: "index",
            label: "No.",
            thStyle: "width:20px",
          },
          {
            key: "company",
            label: "Company",
          },
          {
            key: "kodeacc",
            label: "Account",
          },
          {
            key: "uraian",
            label: "Description",
          },
          {
            key: "umasuk",
            label: "Debit",
            thStyle: "width:150px",
            thClass: "text-right",
            tdClass: "text-right"
          },
          {
            key: "ukeluar",
            label: "Credit",
            thStyle: "width:150px",
            thClass: "text-right",
            tdClass: "text-right"
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:40px",
            thClass: "text-center",
          }          
        ],
    };
  },
  computed: {
    uanguser(){
      return this.$store.state.user.matauang;
    },
    invalidAyatJurnal() {
      this.$v.ayatJurnal.obj.$touch();
      return this.$v.ayatJurnal.obj.$invalid;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
  },
  watch: {
    "model.tanggal": function(val) {
      if (val) {
        this.tahun = moment(val).format('YYYY');
      }
    }
  },
  created: async function (){
     const { user } = this.$store.state;
      
      if ((this.$route.params.nomor) && (this.$route.params.tanggal))  {
          this.kunciTgl=true;
          toastr.info('Loading Journal Detail, please wait')
          try {
            this.$route.params.tanggal= moment(this.$route.params.tanggal).format('YYYY-MM-DD');
            const data = await buku.detail(this.$route.params);  
            const row = data[0][0];
            this.model.tanggal = row.tanggal ? moment(row.tanggal).format('YYYY-MM-DD') : '';
            this.model.nomor = row.nomor;
            // if (this.model.tanggal<this.$store.state.user.tglaktifconsol) {
            //     this.saveEnabled=false;
            // }

            this.model.tgllama = row.tanggal ? moment(row.tanggal).format('YYYY-MM-DD') : '';
            this.model.nomorlama = row.nomor;
            this.model.reff = row.reff;
            this.model.kodejurnal = row.kodejurnal;

            this.ayatJurnal.items = data[0];
            this.calcTotal();
            // this.$forceUpdate();
            toastr.clear;
          } catch (error) {
              console.log('error : ', error);
              toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
      } else  if  (this.$route.params.tanggal)  {
          this.model.tanggal = moment(this.$route.params.tanggal).format('YYYY-MM-DD');
          this.kunciTgl=true;
          // toastr.info('Loading Journal Detail, please wait')
          // try {
          //   this.$route.params.tanggal= moment(this.$route.params.tanggal).format('YYYY-MM-DD');
          //   const data = await buku.detailtanggal(this.$route.params);  
          //   const row = data[0][0];
          //   this.model.tanggal = row.tanggal ? moment(row.tanggal).format('YYYY-MM-DD') : '';
          //   this.model.nomor = row.nomor;

          //   this.model.tgllama = row.tanggal ? moment(row.tanggal).format('YYYY-MM-DD') : '';
          //   this.model.nomorlama = row.nomor;
          //   this.model.reff = row.reff;
          //   this.model.kodejurnal = row.kodejurnal;

          //   this.ayatJurnal.items = data[0];
          //   this.calcTotal();
          //   this.tanggalBerubah();
          //   // this.$forceUpdate();
          //   toastr.clear;
          // } catch (error) {
          //     console.log('error : ', error);
          //     toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          // }

      }
  },
  methods: {
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    closeAyatJurnal: function(){
        const opened= this.ayatJurnal.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    addAyatJurnal : function () {
      this.closeAyatJurnal();
        const obj={_showDetails:true};
        this.ayatJurnal.selected = obj;
        // for (var key in this.ayatJurnal.obj) {
        //     this.ayatJurnal.obj[key] = '';
        // }
      this.ayatJurnal.obj.bukukey= '',
      this.ayatJurnal.obj.nomor='',
      this.ayatJurnal.obj.tanggal='',
      this.ayatJurnal.obj.compcode= '',
      this.ayatJurnal.obj.kodeacc= '',
      this.ayatJurnal.obj.glAccount='',
      this.ayatJurnal.obj.namaacc= '',
      this.ayatJurnal.obj.umasuk= 0,
      this.ayatJurnal.obj.ukeluar= 0,

        this.ayatJurnal.items.push(obj);
        this.ayatJurnal.total=this.ayatJurnal.items.length;
    },
    editAyatJurnal : function (obj,callback) {
      this.closeAyatJurnal();
        this.ayatJurnal.selected = obj;
        for (var key in this.ayatJurnal.obj) {
            this.ayatJurnal.obj[key] = '';
        }
        for (var key in obj) {
            this.ayatJurnal.obj[key] = obj[key];
        }
        callback();
    },
    delAyatJurnal: function (index) {
        if (index > -1) {
        this.ayatJurnal.items.splice(index, 1);
        }
        this.ayatJurnal.total=this.ayatJurnal.items.length;
        this.calcTotal();
    },
    saveAyatJurnal: async function (callback) {
        this.ayatJurnal.obj.umasuk = this.ayatJurnal.obj.umasuk || 0;
        this.ayatJurnal.obj.ukeluar = this.ayatJurnal.obj.ukeluar || 0;
        if ((this.invalidAyatJurnal) || ((this.ayatJurnal.obj.umasuk===0) && (this.ayatJurnal.obj.ukeluar==0))) {
            toastr.error('Please fill the form correctly.');
       } else {
            let datadim=this.ayatJurnal.obj;
            try {

                    for (var key in this.ayatJurnal.obj) {
                        this.ayatJurnal.selected[key] = this.ayatJurnal.obj[key];
                    }

                    this.ayatJurnal.items.sort(
                          function(a, b) {          
                              if (parseFloat(a.umasuk) === parseFloat(b.umasuk)) {
                                // ukeluar is only important when umasuk are the same
                                return parseFloat(b.ukeluar) - parseFloat(b.ukeluar);
                              }
                              return parseFloat(b.umasuk) - parseFloat(a.umasuk);
                          });
                    this.calcTotal();
                    this.ayatJurnal.selected._showDetails=false;
                    if (callback) callback();
            } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error));                
            }
        }
    },
    onSelectLkuCoa(_selected) {
        this.ayatJurnal.obj.glAccount = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
        this.ayatJurnal.obj.kodeacc = _selected.kodeacc;
        this.ayatJurnal.obj.namaacc = _selected.namaacc;
        this.lkuCoaShow=false;
    },
    onSelectLkuCompany: async function (_selected) {
      if (this.ayatJurnal.obj.compcode != _selected.compcode) {
            this.ayatJurnal.obj.compcode= _selected.compcode;
            this.ayatJurnal.obj.company= _selected.company;
      }
      this.lkuCompanyShow=false;
    },      
    save: async function () {
        console.log('Save Clicked');
        if (!this.saveEnabled) {
            toastr.error('View mode cannot be Saved');
            return;
        }
        if (this.invalidModel) {
            console.log('validation model : ', this.$v.model);
            console.log('model obj : ',this.model);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else if (Math.abs(this.totalDb-this.totalCr)>0.5) {
            toastr.error('Amount DEBIT & CREDIT not Balance ', "ERROR MESSAGE");
        } else {
            try {
              let tanggal = moment(this.model.tanggal).format('YYYY-MM-DD');
              let lines = this.ayatJurnal.items.reduce((newArr, item) => {
                  if ((item.kodeacc || '') != '')
                  {
                      item.tanggal = tanggal;
                      item.nomor = this.model.nomor;
                      item.reff = this.model.reff;
                      item.kodejurnal = this.model.kodejurnal;
                      if (!(item.fsubkode2)) {
                        // item.fsubkode1 = this.fsubkode1;
                        // item.kodefield1 = this.kodefield1;
                        // item.subkode1 = this.subkode1;
                        item.fsubkode2 = item.fsubkode2 || this.fsubkode2;
                        item.kodefield2 = item.kodefield2 || this.kodefield2;
                        item.subkode2 = item.subkode2 || this.subkode2;       
                      }
                      newArr.push(item);
                  }
                  return newArr;
              }, []);
              let row={nomor:this.model.nomorlama, tanggal:this.model.tgllama, lines:lines};
              // console.log('jurnal playload : ',row);
              await buku.insert(row);
              toastr.success("Complete successfully", "Save Jurnal");
              this.close();
            } catch (error) {
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }        
            }
        }
    },
    calcTotal: function () {
        let totalDb =  0;
        let totalCr =  0;
        // let totalRow =  0;
        this.ayatJurnal.items.forEach((trx)=> {
            totalDb = totalDb + parseFloat(trx.umasuk || 0);
            totalCr = totalCr + parseFloat(trx.ukeluar || 0);
            // totalRow += 1 ;
        });
        this.totalDb =  totalDb;
        this.totalCr =  totalCr;
        this.totalRow =  this.ayatJurnal.items.length;
    },
    mutasiDb: function () {
        this.ayatJurnal.obj.ukeluar =  0;
    },
    mutasiCr: function () {
        this.ayatJurnal.obj.umasuk =  0;
    },
    mutasiBalik: function () {
        let temp = parseFloat(this.ayatJurnal.obj.umasuk);
        this.ayatJurnal.obj.umasuk =  parseFloat(this.ayatJurnal.obj.ukeluar);
        this.ayatJurnal.obj.ukeluar = temp;
        this.$forceUpdate();
    },
    close(){
      if ((this.$store.state.prevRoute.name) && (this.$route.name !==this.$store.state.prevRoute.name)) {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
        router.push({ name: "consolidation.kertaskerja" });
      }      
    },    
  }
};
</script>
